export const HASH_OPTIONS = ["MD5", "SHA-1", "SHA-2", "SHA-3", "SHA-256", "SHA-512"];
export const CRYPTOGRAPHY_OPTIONS = [
  "AES", "DES", "RSA", "ELGamal", "Diffie-Hellman", "Caesar", "Homophonic", "Polyalphabetic", "Matrix Cipher"
];
export const PROTOCOL_OPTIONS = []
export const ATTACK_OPTIONS = []
export const DATA_TYPE_OPTIONS = [
  "Decimal", "Binary", "Hexadecimal", "Text (UTF-16)"
];